<template>
  <div class="vh-100 vw-100">
    <div class="col-10 col-md-6 col-lg-6 pt-5 mx-auto">
      <img class="w-100" src="https://70000tons.com/wp-content/uploads/2023/03/70K_WEBSITE_BGRND_LOGO.png">
    </div>
    <div class="vw-100 py-3" style="height: 62vh;">
      <div class="row align-items-start my-0 h-100">
        <div class="col-12 col-md-5 col-lg-5" :class="{ 'mt-5': (status == 'Open'), 'my-auto': (status != 'Open') }">
          <NumberDisplay v-if="status == 'Open'" :from="from" :to="to" class="mt-3"/>
          <div v-if="status == 'Soon'" class="my-auto"><div class="text">The merch store will resume<br/>with number</div><br/><div class="soon-text"> {{ from }} </div> </div>
          <div v-if="status == 'Closed'" class="text my-auto">The merch store is closed.</div>
          <div v-if="status == 'Last Chance'" class="text my-auto">CALLING ALL NUMBERS <br/><span class="red" style="font-size: 2.6rem !important;">LAST CHANCE!</span></div>
        </div>
        <div class="d-none d-lg-inline col-md-5 col-lg-5 mt-3">
          <SlideShow/>
        </div>
      </div>
    </div>
    <div class="d-none d-lg-inline col-md-12 col-lg-12 h-auto pb-3 store-hours">
      <DateTime/>
      <div>STORE HOURS </div>
      <span>DAY 2; 07;00 - 22;00 | DAY 3; 17;00 - 22;00 | DAY 4; 07;00 - 12;00</span>
    </div>
  </div>
</template>

<script>
import { getNowServing } from '../services/nowServing.js'
import SlideShow from './SlideShow'
import DateTime from './DateTime'
import NumberDisplay from './NumberDisplay'

export default {
  name: 'MainDisplay',
  components:{
    NumberDisplay,
    SlideShow,
    DateTime
  }
  ,
  data() {
    return {
      status: '',
      from: 0,
      to: 0,
      timer: null,
      audioPath: process.env.BASE_URL+'/sfx/bell.mp3'
    }
  },
  methods: {
    getNowServing() {
      getNowServing().then(response => {
        let statusStr = ['Open', 'Soon', 'Closed', 'Last Chance']
        this.status = statusStr[response.status];
        
        if ((this.from !== response.from || this.to !== response.to) && this.status != 'Closed'){
          this.from = response.from;
          this.to = response.to;
          var audio = new Audio(this.audioPath);
          audio.play();
        }
      });

    }
  },
  created() {
    this.getNowServing();
  },
  mounted() {
    this.timer = setInterval(() => {
      this.getNowServing()
    }, 5000); // in milliseconds
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.store-hours {
  /* font-size: 1.5vw; */
  font-size: 1.4rem;
  font-family: "Egoistism";
  /* font-style: italic; */
}
.text {
  /* font-size: 2.5vw; */
  font-size: 2rem;
  font-family: "Egoistism";
  font-style: italic;
}
.soon-text {
  /* font-size: 8vw; */
  font-size: 3.6rem;
  font-family: "Egoistism";
  font-style: italic;
  /* line-height: 150px; */
  color: #FF0000;
}
.red {
  color: red;
}
@media (min-width:768px) {
  .text {
    /* font-size: 2.5vw; */
    font-size: 3rem;
    font-family: "Egoistism";
    font-style: italic;
  }
  .soon-text {
    /* font-size: 8vw; */
    font-size: 9.6rem;
    font-family: "Egoistism";
    font-style: italic;
    /* line-height: 150px; */
    color: #FF0000;
  }
}
</style>
